export enum ETooltipTheme {
    light = 'light',
    dark = 'dark',
}

export interface IProps {
    text: string;
    theme?: ETooltipTheme;
}
